<template>
  <div class="limit-image-tips" v-if="!isAdulted && visible">
    <template v-if="isLogined && isVerifyed">
      <span>很遗憾，该内容只为18岁以上用户开放，请先积累人生经验值吧！</span>
    </template>
    <template v-else>
      <span>
        高清立绘需
        <span style="color: #4DC3FF;padding: 0 0px;cursor: pointer;" @click="openLimitAuth">
          {{ !isLogined ? "登录" : "实名" }}
        </span>
        后才能观看哦～
      </span>
    </template>
    <img class="close-btn" src="@/assets/nikke_imgs/limit-tips-close.png" alt="" @click="close" />
  </div>
</template>

<script>
import eventBus from "@/plugins/eventBus";

export default {
  name: "LimitImageTips",
  props: {},
  data() {
    return {
      visible: true
    };
  },
  computed: {
    // 是否已登录
    isLogined() {
      return !!(this.loginUser && this.loginUser.uid);
    },
    // 是否已认证
    isVerifyed() {
      return this.isLogined && this.loginUser.verify_level === 2;
    },
    // 是否成人
    isAdulted() {
      return this.isVerifyed && this.loginUser.adulthood;
    }
  },
  mounted() {
    setTimeout(() => {
      this.close();
    }, 5000);
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    openLimitAuth() {
      if (!this.isLogined) {
        eventBus.$emit("onShowLogin");
      } else {
        eventBus.$emit("onShowAuthRealName");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.limit-image-tips {
  padding: 13px 15px;
  height: 40px;
  background: url("~@/assets/nikke_imgs/limit-tips-bg.png") no-repeat;
  background-size: 100% 100%;
  font-size: 14px;
  color: #ffffff;
  line-height: 17px;
  display: flex;
  align-items: center;
  gap: 10px;
  .icon {
    font-size: 28px;
  }

  .close-btn {
    position: absolute;
    right: -20px;
    top: 23px;
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
}
</style>
